// FocusedWord.tsx

interface FocusedWordProps {
    originalWord: string
    wordData: {
        Word: string
        Color: string
        Pre: string
        Stress: string
        Post: string
    }
    icon: React.ReactNode,
    isStressedCompoundNoun: boolean,
}

const FocusedWord: React.FC<FocusedWordProps> = ({
    originalWord,
    wordData,
    icon,
    isStressedCompoundNoun,
}) => {
    const stressStart = wordData.Pre.length;
    const stressEnd = stressStart + wordData.Stress.length;

    const prefix = originalWord.slice(0, stressStart);
    const stress = originalWord.slice(stressStart, stressEnd);
    const suffix = originalWord.slice(stressEnd);

    const isLandscape = window.innerWidth > window.innerHeight;
    return (
        <span style={{ fontSize: '20px', fontWeight: isStressedCompoundNoun ? "bold" : "normal", margin: "20px 0" }}>
            {prefix}
            <span
                style={{
                    position: 'relative',
                    display: 'inline-block',
                    fontSize: '20px',
                }}
            >
                <span style={{ textDecoration: 'underline', fontSize: '20px' }}>
                    {stress}
                </span>
                <div
                    style={{
                        position: 'absolute',
                        top: '100%',
                        left: '50%',
                        transform: 'translateX(-50%)',
                    }}
                >
                    {icon}
                </div>
            </span>
            {suffix}{' '}
        </span>
    );
};

export default FocusedWord
